<template>
    <div @click="closeFilters()" class="filters-page">
        <div v-on:click.stop class="filters-page-container">
            <div class="filter-header">
                <p>Filters <span v-if="totalCurrentFilters > 0">({{totalCurrentFilters}})</span></p>
                <img @click="closeFilters()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            </div>
            <div class="filters-container">
                <div class="product-sort">
                    <span>Sort By</span> 
                    <select v-model="selectedSortMobile">
                        <option value="1">Recommended</option>
                        <option value="2">Best Seller</option>
                        <option value="3">New</option>
                        <option value="4">Price Low to High</option>
                        <option value="5">Price High to Low</option>
                    </select>
                </div>
                <OccasionFilter/>
                <PriceFilter v-if="maxMinPrices" :prices="maxMinPrices"/>
            </div>
            <div class="button-container">
                <button @click="resetFilters" class="happybox-button white border">Reset</button>
                <button @click="applyFilters" class="happybox-button green border">Apply</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OccasionFilter from './OccasionFilterMobile.vue';
import PriceFilter from './PriceFilterMobile.vue';
export default {
    components: {
        OccasionFilter,
        PriceFilter,
    },
    data() {
        return{
        }
    },
    props:{
        filteredAddons: Array,
        filteredPreAddons: Array
    },
    computed: {
        ...mapGetters([
            'occasions',
            'collectionProducts',
            'rangePriceMobile',
            //True filters Start
            'selectedOccasion',
            'selectedSort',
            'rangePrice',
            //True filters END
        ]),
        selectedOccasionMobile: {
            get(){ return this.$store.state.selectedOccasionMobile},
            set(value){this.$store.commit('setSelectedOccasionMobile', value )}
        },
        selectedSortMobile: {
            get(){ return this.$store.state.selectedSortMobile},
            set(value){this.$store.commit('setSelectedSortMobile', value )}
        },
        currentOccasions(){
            return this.occasions;
        },
        maxMinPrices(){
            var prices = this.currentMobilePreAddons.map(x => x.variants[0].price);
            if(prices.length > 0){
                var min = Math.floor(Math.min( ...prices )),
                max = Math.ceil(Math.max( ...prices ));

                return {min: min,max:max};
            }
            return null
        },
        currentMobilePreAddons(){
            let filterAddons =  JSON.parse(JSON.stringify(this.collectionProducts));
            //filter via occasion
            if(this.selectedOccasionMobile.filter(x => x != "View All").length > 0)
                filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasionMobile.some(z => y.includes(z))));
            
            return filterAddons;
        },
        currentMobileAddons(){
            return this.currentMobilePreAddons.filter(x => ((x.variants[0].price-this.rangePriceMobile.min)*(x.variants[0].price-this.rangePriceMobile.max) <= 0));
        },
        totalCurrentFilters(){
            let total = this.selectedOccasionMobile.filter(x => x != "View All").length;
            return total
        }
    },
    methods: {
        closeFilters(){
            //Reset the mobile filters to the true filters
            this.selectedSortMobile = JSON.parse(JSON.stringify(this.selectedSort));
            this.$store.commit('setAllSelectedOccasionMobile', JSON.parse(JSON.stringify(this.selectedOccasion)))
            this.$store.commit('setRangePriceMobile', JSON.parse(JSON.stringify(this.rangePrice)) )
            this.$emit("closefilter");
        },
        resetFilters(){
            this.$store.commit('setAllSelectedOccasion', ["View All"] )
            this.$store.commit('setSelectedSort', 1 )
            this.$store.commit('setRangePrice', {min:0,max:100} )
            this.closeFilters();
        },
        applyFilters(){
            //Change the mobile filters to the true filters
            this.$store.commit('setAllSelectedOccasion', JSON.parse(JSON.stringify(this.selectedOccasionMobile )))
            this.$store.commit('setSelectedSort', JSON.parse(JSON.stringify(this.selectedSortMobile )))
            this.$store.commit('setRangePrice', JSON.parse(JSON.stringify(this.rangePriceMobile)))
            this.$emit("closefilter");
        },
    }
}
</script>

<style scoped>
.filters-page{
    width: 100%;
    height: calc(100% - 80px);
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 4;
    transition: height 0.5s;
    display: flex;
    justify-content: flex-end;
}
.filters-page-container{
    width: 75%;
    max-height: 100%;
    min-height: 100%;
    height: 100%;
    background-color: white;
    overflow-y: scroll;
    padding-bottom: 17%;
}

.filters-container{
    padding: 0% 5% 5% 5%;
}

.filter-header{
    box-shadow: inset 0px -1px 0px #e6e8ec;
    display: flex;
    padding: 5%;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    justify-content: space-between;
    align-items: center;
}

.filter-header p{
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    color: #000000;
    margin: unset;
}

.filter-header button{
    font-size: 25px;
    line-height: 1;
    color: black;
    padding-right: 5%;
    z-index: 1;
}



.product-sort{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0px -1px 0px #E6E8EC;
    padding: 5% 0%;
}

.product-sort span{
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.3;
    color: #0F0C38;
}

.product-sort select{
    width: 65%;
    padding: 2% 8% 2% 2%;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    font-size: 1rem;
    line-height: 1.3;
    color: #0F0C38;
    height: unset;
}

.button-container{
    width: 75%;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    box-shadow: inset 0px 1px 0px #E6E8EC;
    padding: 3% 0%;
    background-color: white;
    z-index: 1;
}

.button-container button{
    width: 44%;
}

.x{
    width: 20px;
    cursor: pointer;
}

@media screen and (min-width: 768px){
    .filters-page{
        justify-content: flex-start;
    }

    .filters-page-container{
        width: 20%;
    }

    .button-container{
        right: unset;
        width: 20%;
        left: 0;
    }

    .filters-container .product-sort{
        display: none;
    }
}
</style>